import { render, staticRenderFns } from "./feedbackRecord.vue?vue&type=template&id=1f004268"
import script from "./feedbackRecord.vue?vue&type=script&lang=js"
export * from "./feedbackRecord.vue?vue&type=script&lang=js"
import style0 from "./feedbackRecord.vue?vue&type=style&index=0&id=1f004268&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports